import styled from 'styled-components';
import DefaultPopup from '@ertelecom/ui-react/components/popups/defaultPopup';
import { FONTS } from '@ertelecom/ui-react/assets/js/constants';

export const ResponsePopup = styled(DefaultPopup)`
  padding: 50px;
  width: calc(100% - 20px) !important;
  max-width: 896px !important;
  @media (max-width: 1024px) {
    max-width: 690px !important;
  }
  @media (max-width: 800px) {
    max-width: 530px !important;
  }
`;

export const Text = styled.div`
  display: block;
  font-size: 32px;
  line-height: 1.33;
  font-family: ${FONTS.regular};
  
  @media (max-width: 767px) {
    font-size: 14px;
  }
`;
